
import PAAttendee from "./Attendee";
import dayjs from "dayjs";

class SupplyItem {

    constructor() {

        const _temp = PAAttendee.generateRandomString(24);
        this.temp_id = _temp;
        this.id = _temp;
        this.name = "";
        this.category = "supplies";
        this.sub_category = "";

        this.assigned_by = "";
        this.assigned_to = "";
        this.private = false;
        this.essential = false;
        this.essential_id = 0;
        this.notes = "";

        this.status = 1;

    }

}

export default SupplyItem;
